module.exports = __webpack_public_path__ + "img/antes_despues_330.334dee0a.png";